export default [
  {
    path: 'gestao/entidades/revenda',
    name: 'revenda',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Agência',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Rede', link: 'entidades' },
        { name: 'Agência' }
      ]
    }
  }
]